module.exports = __webpack_public_path__ + "img/habitation-mal-isole.a61f971a.svg";